import { ChildProps } from "ts/types";

export default function Wrapper({ children }: ChildProps) {
  return <div className="px-4 sm:px-6 lg:px-8">{children}</div>;
}
